import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import baseURL from "../../../../Url/NodeBaseURL";
import InputField from "../../../Pages/InputField/InputField";
import { FaTrash, FaCamera, FaUpload } from "react-icons/fa";
import { Col, Row, Button, Dropdown, DropdownButton } from "react-bootstrap";
import useProductHandlers from "../SalesForm/hooks/useProductHandlers";
import Webcam from "react-webcam";

const OrderProductsPage = () => {
  const navigate = useNavigate();
  const { order_number } = useParams();
  const [data, setData] = useState([]);
  const [orderDetails, setOrderDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showWebcam, setShowWebcam] = useState(false);
  const [productVendors, setProductVendors] = useState({});
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [showSampleOptions, setShowSampleOptions] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [submissions, setSubmissions] = useState([]);
  const [products, setProducts] = useState([]);
  const [showAssignForm, setShowAssignForm] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [subcategoryOptions, setSubcategoryOptions] = useState([]);
  const [vendorAssignments, setVendorAssignments] = useState({});
  const webcamRef = useRef(null);
  const imageInputRef = useRef(null);
  const fileInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const [samplepurityOptions, setSamplePurityOptions] = useState([]);
  const [purityOptions, setpurityOptions] = useState([]);
  const { metaltypeOptions } = useProductHandlers();
  const [showGenerateSale, setShowGenerateSale] = useState(false);
  const [generateSaleMode, setGenerateSaleMode] = useState(false);
  const [selectedProductsGeneration, setSelectedProductsGeneration] = useState(
    []
  );

  const handleCheckboxChange = (productId) => {
    setSelectedProductsGeneration((prev) => {
      const product = orderDetails.find((p) => p.id === productId);

      if (!product) return prev;
      if (product.is_sales_generated) {
        return prev;
      }

      return prev.some((p) => p.id === productId)
        ? prev.filter((p) => p.id !== productId)
        : [...prev, product];
    });
  };
  const [formData, setFormData] = useState({
    hm_type: "",
    hm_charges: "",
    wastage_percent: "",
    metals: [
      {
        metal_type: "",
        metal_purity: "",
        custom_purity: "",
        metal_weight: "",
        rate: "",
        additional_description: "",
        additional_images: [],
      },
    ],
    sample: [
      {
        sample_photo: [],
        sample_des: "",
        sample_wt: "",
        sample_metaltype: "",
        sample_purity: "",
        sample_custom_purity: "",
        custom_sample_purity: "",
      },
    ],
    payment_mode: "",
    advance_amt: "",
    sub_category: "",
  });
  const [currentRates, setCurrentRates] = useState({
    rate_16crt: "",
    rate_18crt: "",
    rate_22crt: "",
    rate_24crt: "",
    silver_rate: "",
  });
  useEffect(() => {
    const fetchCurrentRates = async () => {
      try {
        const response = await axios.get(`${baseURL}/get/current-rates`);
        if (response.data) {
          setCurrentRates({
            rate_16crt: response.data.rate_16crt || "",
            rate_18crt: response.data.rate_18crt || "",
            rate_22crt: response.data.rate_22crt || "",
            rate_24crt: response.data.rate_24crt || "",
            silver_rate: response.data.silver_rate || "",
          });
        }
      } catch (error) {
        console.error("Error fetching current rates:", error);
      }
    };

    fetchCurrentRates();
  }, []);

  const calculateMetalRate = (metal, currentRates) => {
    let price = 0;
    let finalRate = 0;
    let purity = 0;
    if (metal.metal_purity === "Manual") {
      purity = Number(metal.custom_purity || 0);
    } else {
      purity = Number(
        metal.metal_purity.toString().replace("%", "").trim() || 0
      );
    }

    if (metal.metal_type.toLowerCase() === "silver") {
      price =
        ((Number(currentRates.silver_rate || 0) * purity) / 100) *
        (Number(metal.metal_weight) || 0);
    } else {
      price =
        ((Number(currentRates.rate_24crt || 0) * purity) / 99.99) *
        (Number(metal.metal_weight) || 0);
    }

    // let makingCharges = 0;
    // if (metal.hm_type === "MC %") {
    //   makingCharges = ((Number(metal.hm_charges) || 0) * price) / 100;
    // } else if (metal.hm_type === "MC / Gram") {
    //   makingCharges =
    //     (Number(metal.hm_charges) || 0) * (Number(metal.metal_weight) || 0);
    // }

    //finalRate = price + makingCharges;
    finalRate = price;

    return finalRate.toFixed(2);
  };

  const updateRatesForMetals = () => {
    setFormData((prev) => {
      const updatedMetals = prev.metals.map((metal) => ({
        ...metal,
        rate: calculateMetalRate(metal, currentRates),
      }));
      return { ...prev, metals: updatedMetals };
    });
  };

  useEffect(() => {
    if (formData.metals.length > 0) {
      updateRatesForMetals();
    }
  }, [currentRates]);
  //   useEffect(() => {
  //   if (formData.metals.length > 0) {
  //     setFormData((prev) => {
  //       const updatedMetals = prev.metals.map((metal) => ({
  //         ...metal,
  //         rate: calculateMetalRate(metal, currentRates),
  //       }));
  //       return { ...prev, metals: updatedMetals };
  //     });
  //   }
  // }, [formData.metals.length]);

  const handleMetalChange = (index, field, value) => {
    setFormData((prev) => {
      const updatedMetals = [...prev.metals];
      const metal = { ...updatedMetals[index], [field]: value };

      // Handle metal_type logic
      if (field === "metal_type") {
        const lowerValue = value.toLowerCase();
        const prevMetalLower = updatedMetals[index].metal_type?.toLowerCase();

        // if (prevMetalLower === "silver" && lowerValue !== "silver") {
        //   metal.hm_type = "MC %";
        //   metal.hm_charges = "";
        // } else if (prevMetalLower !== "silver" && lowerValue === "silver") {
        //   metal.hm_type = "MC / Gram";
        //   metal.hm_charges = "";
        // }
      }

      if (field === "hm_type") {
        if (value !== updatedMetals[index].hm_type) {
          if (!updatedMetals[index].isTagSelected) {
            metal.hm_charges = "0";
          } else {
            metal.hm_charges = updatedMetals[index].hm_charges;
          }
        }
      }
      metal.rate = calculateMetalRate(metal, currentRates);
      updatedMetals[index] = metal;
      return { ...prev, metals: updatedMetals };
    });
  };
  const handleSampleChange = (index, field, value) => {
    setFormData((prevData) => {
      const updatedSamples = [...prevData.sample];

      // Update the specific field in the sample at the given index
      updatedSamples[index] = {
        ...updatedSamples[index],
        [field]: value,
      };

      return { ...prevData, sample: updatedSamples };
    });
  };
  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleSampleImageChange = (e, sampleIndex) => {
    const files = Array.from(e.target.files);
    const newImages = [];

    files.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        newImages.push(reader.result);
        if (newImages.length === files.length) {
          setFormData((prev) => {
            // Ensure the sample at sampleIndex exists
            const updatedSamples = [...(prev.sample || [])];
            if (!updatedSamples[sampleIndex]) updatedSamples[sampleIndex] = {};

            updatedSamples[sampleIndex] = {
              ...updatedSamples[sampleIndex],
              sample_photo: [
                ...(Array.isArray(updatedSamples[sampleIndex].sample_photo)
                  ? updatedSamples[sampleIndex].sample_photo
                  : []),
                ...newImages,
              ],
            };

            return { ...prev, sample: updatedSamples };
          });
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const clearSampleImage = (sampleIndex, imageIndex) => {
    setFormData((prev) => {
      const updatedSamples = [...(prev.sample || [])];
      if (!updatedSamples[sampleIndex]) return prev;

      updatedSamples[sampleIndex] = {
        ...updatedSamples[sampleIndex],
        sample_photo: (updatedSamples[sampleIndex].sample_photo || []).filter(
          (_, i) => i !== imageIndex
        ),
      };

      return { ...prev, sample: updatedSamples };
    });
  };

  const handleImageChange = async (e, productIndex) => {
    const files = Array.from(e.target.files);

    const mediaObjects = await Promise.all(
      files.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve({ src: reader.result, type: file.type });
          };
          reader.onerror = () => reject("Error reading file");
          reader.readAsDataURL(file);
        });
      })
    );

    setFormData((prev) => {
      const updatedMetals = [...prev.metals];
      updatedMetals[productIndex] = {
        ...updatedMetals[productIndex],
        additional_images: [
          ...(Array.isArray(updatedMetals[productIndex].additional_images)
            ? updatedMetals[productIndex].additional_images
            : []),
          ...mediaObjects,
        ],
      };

      return { ...prev, metals: updatedMetals };
    });

    setShowOptions(false);
  };

  const clearImage = (productIndex, imageIndex) => {
    setFormData((prev) => {
      const updatedMetals = [...prev.metals];
      updatedMetals[productIndex] = {
        ...updatedMetals[productIndex],
        additional_images: updatedMetals[productIndex].additional_images.filter(
          (_, i) => i !== imageIndex
        ),
      };

      return { ...prev, metals: updatedMetals };
    });
  };

  const captureImage = (sampleIndex) => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();

      setFormData((prev) => {
        const updatedSamples = [...prev.sample];
        updatedSamples[sampleIndex] = {
          ...updatedSamples[sampleIndex],
          sample_photo: [
            ...(updatedSamples[sampleIndex].sample_photo || []),
            imageSrc,
          ],
        };
        return { ...prev, sample: updatedSamples };
      });

      setShowWebcam(false);
      setShowOptions(false);
    }
  };

  useEffect(() => {
    const fetchSubCategory = async () => {
      try {
        const response = await fetch(`${baseURL}/subcategory`);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const result = await response.json();

        if (result && result.data) {
          const filteredData = formData.metal_type
            ? result.data.filter(
                (item) =>
                  item.metal_type &&
                  item.metal_type.toLowerCase() ===
                    formData.metal_type.toLowerCase()
              )
            : result.data;

          const formattedOptions = filteredData.map((item) => ({
            label: item.sub_category_name,
            value: item.sub_category_name,
          }));
          setSubcategoryOptions(formattedOptions);

          setSubcategoryOptions(formattedOptions);
        } else {
          console.error("Invalid API response format", result);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchSubCategory();
  }, [formData.metal_type]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(`${baseURL}/get/products`);
        if (!response.ok) {
          throw new Error("Failed to fetch products");
        }
        const result = await response.json();
        setProducts(result);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, []);
  const fetchAssignmentsForProducts = async (products) => {
    const assignmentsMap = {};

    for (const product of products) {
      const vendorId = product.vendor_id;
      const productId = product.id;

      if (!vendorId) continue;

      try {
        const res = await axios.get(
          `${baseURL}/vendor/${vendorId}/assignments/${productId}`
        );
        assignmentsMap[productId] = res.data[0];
      } catch (err) {
        console.error(
          `Error fetching assignment for product ${productId}:`,
          err
        );
      }
    }

    setVendorAssignments(assignmentsMap);
  };

  const fetchOrderDetails = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/get-order-details/${order_number}`
      );
      const repeatedData = response.data.repeatedData || [];
      setOrderDetails(repeatedData);
      let filteredData = repeatedData.filter(
        (item) => item.transaction_status === "Orders"
      );
      const hasAtLeastOneSelected = repeatedData.some(
        (item) => item.submission_status === "selected"
      );
      filteredData = filteredData.filter(
        (item) => item.invoice_number === null
      );
      console.log("filtered data is", filteredData);

      setShowGenerateSale(hasAtLeastOneSelected);
      setData(filteredData);
      //const productIds = filteredData.map((item) => item.id);
      //await fetchSubmissions(productIds);
      await fetchAssignmentsForProducts(filteredData);

      setLoading(false);

      if (filteredData.length > 0) {
        fetchUniquePurchaseDetails(filteredData);
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
      setLoading(false);
    }
  };

  // const fetchSubmissions = async (productIds) => {
  //   try {
  //     const res = await axios.get(`${baseURL}/admin/submissions`);
  //     const all = res.data;
  //     const approved = all.filter(
  //       (item) => productIds.includes(item.product_id) && item.is_approved === 1
  //     );
  //     setSubmissions(approved);
  //   } catch (err) {
  //     console.error("Error fetching submissions:", err);
  //   }
  // };
  const fetchUniquePurchaseDetails = async (orderData) => {
    try {
      const purchaseRes = await axios.get(
        `${baseURL}/get-unique-purchase-details`
      );
      const uniqueDetails = purchaseRes.data || [];

      const accountRes = await axios.get(`${baseURL}/get/account-details`);
      const accounts = accountRes.data || [];

      const productVendorMap = {};

      for (const product of orderData) {
        const { id, metal_type, category } = product;

        const matched = uniqueDetails.filter(
          (item) => item.metal_type === metal_type && item.category === category
        );

        const uniqueByMobile = [];
        const seenMobiles = new Set();

        for (const item of matched) {
          if (!seenMobiles.has(item.mobile)) {
            seenMobiles.add(item.mobile);
            uniqueByMobile.push(item);
          }
        }

        const vendorsWithIds = uniqueByMobile.map((vendor) => {
          const matchedAccount = accounts.find(
            (acc) =>
              acc.account_name === vendor.account_name &&
              acc.mobile === vendor.mobile
          );
          return {
            ...vendor,
            account_id: matchedAccount?.account_id || null,
          };
        });

        productVendorMap[id] = vendorsWithIds;
      }

      setProductVendors(productVendorMap);
    } catch (error) {
      console.error(
        "Error fetching unique purchase or account details:",
        error
      );
    }
  };

  const handleAssignmentSubmit = async () => {
    if (!selectedProduct || !selectedVendor) return;
    const validMetals = formData.metals.filter(
      (metal) =>
        metal.metal_type?.trim() &&
        metal.metal_purity &&
        Number(metal.metal_weight) > 0
    );
    const validSamples = formData.sample.filter(
      (sample) =>
        sample.sample_metaltype?.trim() &&
        sample.sample_purity &&
        Number(sample.sample_wt) > 0
    );

    const payload = {
      orderNumber: order_number,
      productId: selectedProduct.id,
      vendorId: selectedVendor.account_id,
      vendorName: selectedVendor.account_name,
      assignedBy: "admin",
      status: "Assigned",
      hm_type: formData.hm_type,
      hm_charges: formData.hm_charges,
      wastage_percent: formData.wastage_percent,
      metals: validMetals,
      samples: validSamples,
      payment_mode: formData.payment_mode,
      advance_amt: formData.advance_amt,
      sub_category: formData.sub_category,
    };
    try {
      setLoading(true);
      const response = await axios.post(`${baseURL}/assignments`, payload);
      if (response.status === 201) {
        alert("Assignment submitted successfully");
        setShowAssignForm(false);
        setFormData({
          hm_type: "",
          hm_charges: "",
          wastage_percent: "",
          metals: [
            {
              metal_type: "",
              metal_purity: "",
              metal_weight: "",
              additional_description: "",
              additional_images: [],
            },
          ],
          sample: [
            {
              sample_photo: [],
              sample_des: "",
              sample_wt: "",
              sample_metaltype: "",
              sample_purity: "",
              sample_custom_purity: "",
            },
          ],
          payment_mode: "",
          advance_amt: "",
          sub_category: "",
        });

        fetchOrderDetails();
      } else {
        alert("Failed to assign.");
      }
    } catch (err) {
      console.error("Error submitting assignment:", err);
      alert("Error submitting assignment.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderDetails();
  }, [order_number]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isDropdown = event.target.closest(".vendor-dropdown");
      const isButton = event.target.closest(".assign-button");

      if (!isDropdown && !isButton) {
        setOpenDropdownIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="main-container" style={{ position: "relative" }}>
      <div className="payments-table-container">
        <Row className="mb-3">
          <Col className="d-flex justify-content-between align-items-center">
            <h3>Products for Order #{order_number}</h3>
            <Button
              className="create_but"
              onClick={() => navigate("/orderstable")}
              style={{ backgroundColor: "#a36e29", borderColor: "#a36e29" }}
            >
              ← Back
            </Button>
          </Col>
        </Row>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div
              style={{
                position: "relative",
                overflowX: "auto",
                overflowY: "auto",
                maxHeight: "70vh",
                zIndex: 1,
              }}
            >
              <table
                className="table table-bordered"
                style={{ marginBottom: 0 }}
              >
                <thead className="thead-light">
                  <tr>
                    {generateSaleMode && <th>Select</th>}
                    <th>Bar Code</th>
                    <th>Product Name</th>
                    <th>Metal Type</th>
                    <th>Purity</th>
                    <th>Gross Wt</th>
                    <th>Stone Wt</th>
                    <th>W.Wt</th>
                    <th>Total Wt</th>
                    <th>Size</th>
                    <th>MC</th>
                    <th>Rate</th>
                    <th>Tax Amt</th>
                    <th>Total Price</th>
                    <th>Actions</th>
                    <th>Vendor Name</th>
                    <th>Vendor Mobile</th>
                    <th>Vendor ID</th>
                    <th>Assignment ID</th>
                    <th>Status</th>
                    {/* <th>Submission</th> */}
                  </tr>
                </thead>
                <tbody>
                  {data.map((product, index) => {
                    const isCancelled = product.refund_amount !== null;
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          {generateSaleMode && (
                            <td>
                              <input
                                type="checkbox"
                                disabled={
                                  isCancelled ||
                                  vendorAssignments[product.id]
                                    ?.submission_status !== "selected" ||
                                  product.is_sales_generated === 1
                                }
                                checked={selectedProductsGeneration.some(
                                  (p) => p.id === product.id
                                )}
                                onChange={() =>
                                  handleCheckboxChange(product.id)
                                }
                              />
                            </td>
                          )}
                          <td>{product.code}</td>
                          <td>{product.product_name}</td>
                          <td>{product.metal_type}</td>
                          <td>
                            {product.purity === "Manual"
                              ? `${product.custom_purity}%`
                              : product.purity}
                          </td>
                          <td>{product.gross_weight}</td>
                          <td>{product.stone_weight}</td>
                          <td>{product.wastage_weight}</td>
                          <td>{product.total_weight_av}</td>
                          <td>{product.size}</td>
                          <td>{product.making_charges}</td>
                          <td>{product.rate}</td>
                          <td>{product.tax_amt}</td>
                          <td>{product.total_price}</td>

                          <td>
                            <div style={{ position: "relative" }}>
                              <button
                                className="btn btn-sm"
                                style={{
                                  backgroundColor: product.vendor_name
                                    ? "#a36e29"
                                    : "#28a745",
                                  borderColor: product.vendor_name
                                    ? "#a36e29"
                                    : "#28a745",
                                  fontSize: "14px",
                                  padding: "4px 8px",
                                  color: "white",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                                disabled={!!product.vendor_name || isCancelled}
                                onClick={() => setOpenDropdownIndex(index)}
                              >
                                {product.vendor_name ? (
                                  <span>Assigned</span>
                                ) : (
                                  <>
                                    <span>Assign to Vendor</span>
                                    {/* <span style={{ fontSize: "12px" }}>▼</span> */}
                                  </>
                                )}
                              </button>

                              {openDropdownIndex === index && (
                                <div
                                  className="vendor-dropdown"
                                  style={{
                                    position: "fixed",
                                    top: "auto",
                                    left: "auto",
                                    zIndex: 9999,
                                    backgroundColor: "#fff",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                                    maxHeight: "200px",
                                    minWidth: "160px",
                                    padding: "4px 0",
                                    overflowY: "auto",
                                  }}
                                  ref={(el) => {
                                    if (el) {
                                      const button = el.previousElementSibling;
                                      const buttonRect =
                                        button.getBoundingClientRect();
                                      const containerRect = document
                                        .querySelector(
                                          ".payments-table-container"
                                        )
                                        .getBoundingClientRect();

                                      // Position dropdown below the button
                                      el.style.top = `${
                                        buttonRect.bottom + 4
                                      }px`;
                                      el.style.left = `${buttonRect.left}px`;

                                      // Check if dropdown would go off screen to the right
                                      const dropdownWidth = el.offsetWidth;
                                      if (
                                        buttonRect.left + dropdownWidth >
                                        window.innerWidth
                                      ) {
                                        el.style.left = `${
                                          window.innerWidth - dropdownWidth - 10
                                        }px`;
                                      }

                                      // Check if dropdown would go off screen to the bottom
                                      const dropdownHeight = Math.min(
                                        200,
                                        el.scrollHeight
                                      );
                                      if (
                                        buttonRect.bottom + dropdownHeight >
                                        window.innerHeight
                                      ) {
                                        el.style.top = `${
                                          buttonRect.top - dropdownHeight - 4
                                        }px`;
                                      }
                                    }
                                  }}
                                >
                                  {!productVendors[product.id] ||
                                  productVendors[product.id].length === 0 ? (
                                    <div
                                      style={{
                                        padding: "8px 12px",
                                        color: "#888",
                                      }}
                                    >
                                      No Vendors
                                    </div>
                                  ) : (
                                    productVendors[product.id].map(
                                      (vendor, i) => (
                                        <div
                                          key={i}
                                          onClick={() => {
                                            setSelectedProduct(product);
                                            setSelectedVendor(vendor);
                                            setFormData({
                                              hm_type: product.mc_on || "",
                                              hm_charges: "",
                                              wastage_percent: "",
                                              metals: [
                                                {
                                                  metal_type:
                                                    product.metal_type || "",
                                                  metal_purity:
                                                    product.purity || "",
                                                  custom_purity:
                                                    product.custom_purity || "",
                                                  metal_weight: "",
                                                  additional_description: "",
                                                  additional_images: [],
                                                },
                                              ],
                                              sample: [
                                                {
                                                  sample_photo: [],
                                                  sample_des: "",
                                                  sample_wt: "",
                                                  sample_metaltype: "",
                                                  sample_purity:
                                                    product.purity || "",
                                                  sample_custom_purity: "",
                                                },
                                              ],
                                              payment_mode: "",
                                              advance_amt: "",
                                              sub_category:
                                                product.sub_category || "",
                                            });
                                            setShowAssignForm(true);
                                            setOpenDropdownIndex(null);
                                          }}
                                          style={{
                                            padding: "5px 8px",
                                            cursor: "pointer",
                                            whiteSpace: "nowrap",
                                            fontSize: "14px",
                                          }}
                                          onMouseEnter={(e) =>
                                            (e.target.style.backgroundColor =
                                              "#f8f9fa")
                                          }
                                          onMouseLeave={(e) =>
                                            (e.target.style.backgroundColor =
                                              "transparent")
                                          }
                                        >
                                          {vendor.account_name} -{" "}
                                          {vendor.mobile}
                                        </div>
                                      )
                                    )
                                  )}
                                </div>
                              )}
                            </div>
                          </td>
                          <td>{product.vendor_name || "-"}</td>
                          <td>{product.vendor_mobile || "-"}</td>
                          <td>{product.vendor_id || "-"}</td>
                          <td>
                            {vendorAssignments[product.id]?.id ||
                              vendorAssignments[product.id]?._id ||
                              vendorAssignments[product.id]?.assignment_id ||
                              "-"}
                          </td>
                          <td className="text-nowrap" style={{ width: "50px" }}>
                            {isCancelled ? (
                              <button
                                className="btn btn-sm btn-danger"
                                disabled
                                style={{
                                  fontSize: "14px",
                                  padding: "4px 8px",
                                  color: "white",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  opacity: 0.8,
                                }}
                              >
                                <span>Cancelled</span>
                              </button>
                            ) : vendorAssignments[product.id]
                                ?.submission_status === "selected" ? (
                              <button
                                className="btn btn-sm"
                                disabled
                                style={{
                                  fontSize: "14px",
                                  padding: "4px 8px",
                                  backgroundColor: "#a36e29",
                                  color: "white",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  opacity: 0.6,
                                }}
                              >
                                <span>Received</span>
                              </button>
                            ) : vendorAssignments[product.id]
                                ?.submission_status === "in review" ? (
                              <button
                                className="btn btn-sm"
                                onClick={() =>
                                  navigate(
                                    `/orderstable/${order_number}/${product.vendor_id}/submission-view/${product.id}`
                                  )
                                }
                                style={{
                                  fontSize: "14px",
                                  padding: "4px 8px",
                                  backgroundColor: "#33c92bff",
                                  color: "white",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <span>In review</span>
                                <span style={{ fontSize: "12px" }}>➔</span>
                              </button>
                            ) : vendorAssignments[product.id]
                                ?.assignment_status === "Assigned" ? (
                              <button
                                className="btn btn-sm btn-secondary"
                                disabled
                                style={{
                                  fontSize: "14px",
                                  padding: "4px 8px",
                                  color: "white",
                                }}
                              >
                                In Progress
                              </button>
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>

                        {showAssignForm &&
                          selectedProduct?.id === product.id && (
                            <tr>
                              <td colSpan="19">
                                <div className="p-4 border rounded bg-white">
                                  <h4>
                                    Assign Product to{" "}
                                    {selectedVendor?.account_name}
                                  </h4>
                                  <Row>
                                    <Col md={3}>
                                      <label>MC Type</label>
                                      <InputField
                                        label=""
                                        name="hm_type"
                                        type="select"
                                        value={formData.hm_type || ""}
                                        onChange={(e) =>
                                          setFormData((prev) => ({
                                            ...prev,
                                            hm_type: e.target.value,
                                          }))
                                        }
                                        options={[
                                          {
                                            value: "MC / Gram",
                                            label: "MC / Gram",
                                          },
                                          {
                                            value: "MC / Piece",
                                            label: "MC / Piece",
                                          },
                                          { value: "MC %", label: "MC %" },
                                          ...(formData.hm_type &&
                                          ![
                                            "MC / Gram",
                                            "MC / Piece",
                                            "MC %",
                                          ].includes(formData.hm_type)
                                            ? [
                                                {
                                                  value: formData.hm_type,
                                                  label: formData.hm_type,
                                                },
                                              ]
                                            : []),
                                        ]}
                                      />
                                    </Col>
                                    <Col md={3}>
                                      <label>
                                        {formData.hm_type === "MC %"
                                          ? "MC %"
                                          : "MC/Gm"}
                                      </label>
                                      <InputField
                                        label=""
                                        name="hm_charges"
                                        value={formData.hm_charges || ""}
                                        onChange={(e) =>
                                          setFormData((prev) => ({
                                            ...prev,
                                            hm_charges: e.target.value,
                                          }))
                                        }
                                        disabled={
                                          formData.hm_type === "MC / Piece"
                                        }
                                      />
                                    </Col>
                                    <Col md={3}>
                                      <label>Wastage Percentage</label>
                                      <InputField
                                        label=""
                                        name="wastage_percent"
                                        value={formData.wastage_percent || ""}
                                        onChange={(e) =>
                                          setFormData((prev) => ({
                                            ...prev,
                                            wastage_percent: e.target.value,
                                          }))
                                        }
                                      />
                                    </Col>
                                  </Row>
                                  {formData.metals.map((metal, index) => (
                                    <div
                                      key={index}
                                      className="mb-4 p-3 border rounded"
                                    >
                                      {/* <h5 className="mt-4">
                                    Metal given to the vendor
                                  </h5> */}
                                      <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
                                        <h5 className="mb-0">
                                          Metal given to the vendor
                                        </h5>

                                        {formData.metals.length > 1 && (
                                          <button
                                            type="button"
                                            onClick={() =>
                                              setFormData((prev) => ({
                                                ...prev,
                                                metals: prev.metals.filter(
                                                  (_, i) => i !== index
                                                ),
                                              }))
                                            }
                                            style={{
                                              background: "transparent",
                                              border: "none",
                                              color: "red",
                                              cursor: "pointer",
                                              fontSize: "18px",
                                            }}
                                          >
                                            <FaTrash />
                                          </button>
                                        )}
                                      </div>
                                      <Row>
                                        <Col md={4}>
                                          <label>Metal Type</label>
                                          <InputField
                                            label=""
                                            name="metal_type"
                                            value={metal.metal_type || ""}
                                            onChange={(e) =>
                                              handleMetalChange(
                                                index,
                                                "metal_type",
                                                e.target.value
                                              )
                                            }
                                            type="select"
                                            options={metaltypeOptions}
                                          />
                                        </Col>
                                        {/* <Col md={3}>
                                  <label>Sub Category</label>
                                  <InputField
                                    label=""
                                    name="sub_category"
                                    type="select"
                                    value={formInput.sub_category || ""}
                                    onChange={(e) =>
                                      setFormInput({
                                        ...formInput,
                                        sub_category: e.target.value,
                                      })
                                    }
                                    options={subcategoryOptions}
                                  />
                                </Col> */}
                                        <Col md={4}>
                                          <label>Purity</label>
                                          <InputField
                                            type="select"
                                            name="metal_purity"
                                            value={metal.metal_purity || ""}
                                            onChange={(e) =>
                                              handleMetalChange(
                                                index,
                                                "metal_purity",
                                                e.target.value
                                              )
                                            }
                                            options={[
                                              ...(metal.metal_purity !==
                                              "Manual"
                                                ? [
                                                    {
                                                      value: metal.metal_purity,
                                                      label: metal.metal_purity,
                                                    },
                                                  ]
                                                : []),
                                              {
                                                value: "Manual",
                                                label: "Manual",
                                              },
                                            ]}
                                          />
                                        </Col>

                                        {metal.metal_purity === "Manual" && (
                                          <Col md={4}>
                                            <label>Custom Purity</label>
                                            <InputField
                                              label=""
                                              name="custom_purity"
                                              value={metal.custom_purity || ""}
                                              onChange={(e) =>
                                                handleMetalChange(
                                                  index,
                                                  "custom_purity",
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </Col>
                                        )}

                                        <Col md={4}>
                                          <label>Metal Weight</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            style={{
                                              border: "1px solid #a36e29",
                                            }}
                                            onChange={(e) =>
                                              handleMetalChange(
                                                index,
                                                "metal_weight",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col>
                                      </Row>

                                      {/* <Row className="mt-3">
                                  <Col md={3}>
                                      <label>MC Type</label>
                                      <InputField
                                        label=""
                                        name="hm_type"
                                        type="select"
                                        value={metal.hm_type || ""}
                                        onChange={(e) =>
                                          handleMetalChange(
                                            index,
                                            "hm_type",
                                            e.target.value
                                          )
                                        }
                                        options={[
                                          {
                                            value: "MC / Gram",
                                            label: "MC / Gram",
                                          },
                                          {
                                            value: "MC / Piece",
                                            label: "MC / Piece",
                                          },
                                          { value: "MC %", label: "MC %" },
                                          ...(metal.hm_type &&
                                          ![
                                            "MC / Gram",
                                            "MC / Piece",
                                            "MC %",
                                          ].includes(metal.hm_type)
                                            ? [
                                                {
                                                  value: metal.hm_type,
                                                  label: metal.hm_type,
                                                },
                                              ]
                                            : []),
                                        ]}
                                      />
                                    </Col>
                                  <Col md={3}>
                                      <label>
                                        {metal.hm_type === "MC %"
                                          ? "MC %"
                                          : "MC/Gm"}
                                      </label>
                                      <InputField
                                        label=""
                                        name="hm_charges"
                                        value={metal.hm_charges || ""}
                                        onChange={(e) =>
                                          handleMetalChange(
                                            index,
                                            "hm_charges",
                                            e.target.value
                                          )
                                        }
                                        disabled={
                                          metal.hm_type === "MC / Piece"
                                        }
                                      />
                                    </Col>
                                  <Col md={6}>
                                      <label>Additional Description</label>
                                      <textarea
                                        className="form-control"
                                        style={{ border: "1px solid #a36e29" }}
                                        value={metal.additional_description}
                                        onChange={(e) =>
                                          handleMetalChange(
                                            index,
                                            "additional_description",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Col>
                                  </Row> */}

                                      <Row className="mt-3">
                                        <Col md={6} className="mt-4">
                                          <div className="d-flex align-items-start gap-3 mt-1">
                                            {/* Button column */}
                                            <div>
                                              <DropdownButton
                                                id="dropdown-basic-button"
                                                title="Additional Images / Videos"
                                                variant="primary"
                                                size="sm"
                                                onClick={() =>
                                                  setShowOptions(!showOptions)
                                                }
                                              >
                                                {showOptions && (
                                                  <>
                                                    <Dropdown.Item
                                                      onClick={() => {
                                                        if (
                                                          imageInputRef.current
                                                        )
                                                          imageInputRef.current.click();
                                                      }}
                                                    >
                                                      <FaUpload /> Choose Image
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                      onClick={() => {
                                                        if (
                                                          videoInputRef.current
                                                        )
                                                          videoInputRef.current.click();
                                                      }}
                                                    >
                                                      <FaUpload /> Choose Video
                                                    </Dropdown.Item>
                                                  </>
                                                )}
                                              </DropdownButton>

                                              {/* Hidden Inputs */}
                                              <input
                                                type="file"
                                                accept="image/*"
                                                multiple
                                                ref={imageInputRef}
                                                style={{ display: "none" }}
                                                onChange={(e) =>
                                                  handleImageChange(e, index)
                                                }
                                              />
                                              <input
                                                type="file"
                                                accept="video/*"
                                                multiple
                                                ref={videoInputRef}
                                                style={{ display: "none" }}
                                                onChange={(e) =>
                                                  handleImageChange(e, index)
                                                }
                                              />
                                            </div>

                                            {/* Preview column */}
                                            {Array.isArray(
                                              formData.metals[index]
                                                .additional_images
                                            ) &&
                                              formData.metals[index]
                                                .additional_images.length >
                                                0 && (
                                                <div className="d-flex flex-wrap gap-2">
                                                  {formData.metals[
                                                    index
                                                  ].additional_images.map(
                                                    (media, Imgindex) => {
                                                      const src =
                                                        typeof media ===
                                                        "string"
                                                          ? media
                                                          : media.src;
                                                      const type =
                                                        media?.type || "";

                                                      const isVideo =
                                                        type.startsWith(
                                                          "video/"
                                                        ) ||
                                                        src.startsWith(
                                                          "blob:"
                                                        ) ||
                                                        src.startsWith(
                                                          "data:video"
                                                        ) ||
                                                        src.endsWith(".mp4") ||
                                                        src.includes(".mp4");

                                                      return (
                                                        <div
                                                          key={Imgindex}
                                                          style={{
                                                            position:
                                                              "relative",
                                                            display:
                                                              "inline-block",
                                                          }}
                                                        >
                                                          {isVideo ? (
                                                            <video
                                                              src={src}
                                                              width="100"
                                                              height="100"
                                                              controls
                                                              style={{
                                                                borderRadius:
                                                                  "8px",
                                                              }}
                                                            />
                                                          ) : (
                                                            <img
                                                              src={src}
                                                              alt={`Preview ${Imgindex}`}
                                                              style={{
                                                                width: "100px",
                                                                height: "100px",
                                                                borderRadius:
                                                                  "8px",
                                                              }}
                                                            />
                                                          )}
                                                          <button
                                                            type="button"
                                                            onClick={() =>
                                                              clearImage(
                                                                index,
                                                                Imgindex
                                                              )
                                                            }
                                                            style={{
                                                              position:
                                                                "absolute",
                                                              top: "5px",
                                                              right: "5px",
                                                              background:
                                                                "transparent",
                                                              border: "none",
                                                              color: "red",
                                                              fontSize: "16px",
                                                              cursor: "pointer",
                                                              zIndex: 10,
                                                            }}
                                                          >
                                                            <FaTrash />
                                                          </button>
                                                        </div>
                                                      );
                                                    }
                                                  )}
                                                </div>
                                              )}
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                  ))}
                                  {/* <button
                                type="button"
                                className="btn mt-3"
                                style={{
                                  backgroundColor: "#a36e29",
                                  color: "white",
                                  fontSize: "14px", // smaller text
                                  padding: "6px 12px", // smaller padding
                                  border: "none",
                                  borderRadius: "6px", // rounded corners
                                }}
                                onClick={() =>
                                  setFormData((prev) => {
                                    const lastMetal =
                                      prev.metals[prev.metals.length - 1];

                                    return {
                                      ...prev,
                                      metals: [
                                        ...prev.metals,
                                        {
                                          metal_type: "",
                                          metal_purity: "Manual",
                                          custom_purity: "",
                                          metal_weight: "",
                                          // hm_type: lastMetal?.hm_type || "",
                                          // hm_charges:
                                          //   lastMetal?.hm_charges || "",
                                          additional_description: "",
                                          additional_images: [],
                                        },
                                      ],
                                    };
                                  })
                                }
                              >
                                Add Metal
                              </button> */}
                                  {(() => {
                                    const lastMetal =
                                      formData.metals[
                                        formData.metals.length - 1
                                      ];

                                    const canAdd =
                                      lastMetal?.metal_type &&
                                      lastMetal?.metal_purity &&
                                      Number(lastMetal?.metal_weight) > 0;

                                    return (
                                      <button
                                        type="button"
                                        className="btn mt-3"
                                        style={{
                                          backgroundColor: canAdd
                                            ? "#a36e29"
                                            : "gray",
                                          color: "white",
                                          fontSize: "14px",
                                          padding: "6px 12px",
                                          border: "none",
                                          borderRadius: "6px",
                                          cursor: canAdd
                                            ? "pointer"
                                            : "not-allowed",
                                        }}
                                        disabled={!canAdd}
                                        onClick={() =>
                                          setFormData((prev) => ({
                                            ...prev,
                                            metals: [
                                              ...prev.metals,
                                              {
                                                metal_type: "",
                                                metal_purity: "Manual",
                                                custom_purity: "",
                                                metal_weight: "",
                                                additional_description: "",
                                                additional_images: [],
                                              },
                                            ],
                                          }))
                                        }
                                      >
                                        Add Metal
                                      </button>
                                    );
                                  })()}

                                  {formData.sample.map((sample, index) => (
                                    <>
                                      <div className="mt-4 p-4 border rounded bg-white">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                          <h5 className="mb-0">
                                            Sample given to the vendor
                                          </h5>

                                          {formData.sample.length > 1 && (
                                            <button
                                              type="button"
                                              onClick={() =>
                                                setFormData((prev) => ({
                                                  ...prev,
                                                  sample: prev.sample.filter(
                                                    (_, i) => i !== index
                                                  ),
                                                }))
                                              }
                                              style={{
                                                background: "transparent",
                                                border: "none",
                                                color: "red",
                                                cursor: "pointer",
                                                fontSize: "18px",
                                              }}
                                            >
                                              <FaTrash />
                                            </button>
                                          )}
                                        </div>
                                        <Row className="mt-3">
                                          <Col md={4}>
                                            <label>Metal Type</label>
                                            <InputField
                                              label=""
                                              name="sample_metaltype"
                                              value={
                                                sample.sample_metaltype || ""
                                              }
                                              onChange={(e) =>
                                                handleSampleChange(
                                                  index,
                                                  "sample_metaltype",
                                                  e.target.value
                                                )
                                              }
                                              type="select"
                                              options={metaltypeOptions}
                                            />
                                          </Col>
                                          <Col md={4}>
                                            <label>Purity</label>
                                            <InputField
                                              type="select"
                                              name="sample_purity"
                                              value={sample.sample_purity || ""}
                                              onChange={(e) =>
                                                handleSampleChange(
                                                  index,
                                                  "sample_purity",
                                                  e.target.value
                                                )
                                              }
                                              options={[
                                                ...(sample.sample_purity !==
                                                "Manual"
                                                  ? [
                                                      {
                                                        value:
                                                          sample.sample_purity,
                                                        label:
                                                          sample.sample_purity,
                                                      },
                                                    ]
                                                  : []),
                                                {
                                                  value: "Manual",
                                                  label: "Manual",
                                                },
                                              ]}
                                            />
                                          </Col>

                                          {sample.sample_purity ===
                                            "Manual" && (
                                            <Col md={4}>
                                              <label>Custom Purity</label>
                                              <InputField
                                                label=""
                                                name="sample_custom_purity"
                                                value={
                                                  sample.sample_custom_purity ||
                                                  ""
                                                }
                                                onChange={(e) =>
                                                  handleSampleChange(
                                                    index,
                                                    "sample_custom_purity",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          )}

                                          <Col md={4}>
                                            <label>Sample Weight</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              style={{
                                                border: "1px solid #a36e29",
                                              }}
                                              value={sample.sample_wt || ""}
                                              onChange={(e) =>
                                                handleSampleChange(
                                                  index,
                                                  "sample_wt",
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </Col>
                                        </Row>
                                        <Row className="mt-3">
                                          <Col md={6}>
                                            <label>Sample Description</label>
                                            <textarea
                                              className="form-control"
                                              style={{
                                                border: "1px solid #a36e29",
                                              }}
                                              value={sample.sample_des || ""}
                                              onChange={(e) =>
                                                handleSampleChange(
                                                  index,
                                                  "sample_des",
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </Col>
                                          <Col md={6} className="mt-4">
                                            <div className="d-flex align-items-start gap-3 mt-1">
                                              {/* Button column */}
                                              <div>
                                                <DropdownButton
                                                  id="dropdown-basic-button"
                                                  title="Choose / Capture Image"
                                                  variant="primary"
                                                  size="sm"
                                                  onClick={() =>
                                                    setShowSampleOptions(
                                                      !showSampleOptions
                                                    )
                                                  }
                                                >
                                                  {showSampleOptions && (
                                                    <>
                                                      <Dropdown.Item
                                                        onClick={() =>
                                                          fileInputRef.current?.click()
                                                        }
                                                      >
                                                        <FaUpload /> Choose
                                                        Image
                                                      </Dropdown.Item>
                                                      <Dropdown.Item
                                                        onClick={() =>
                                                          setShowWebcam(true)
                                                        }
                                                      >
                                                        <FaCamera /> Capture
                                                        Image
                                                      </Dropdown.Item>
                                                    </>
                                                  )}
                                                </DropdownButton>

                                                {/* Hidden File Input */}
                                                <input
                                                  type="file"
                                                  name="image"
                                                  accept="image/*"
                                                  ref={fileInputRef}
                                                  style={{ display: "none" }}
                                                  onChange={(e) =>
                                                    handleSampleImageChange(
                                                      e,
                                                      index
                                                    )
                                                  }
                                                />
                                              </div>

                                              {/* Webcam and Preview Column */}
                                              <div className="d-flex flex-wrap gap-2">
                                                {/* Webcam UI */}
                                                {showWebcam && (
                                                  <div className="d-flex flex-column align-items-start">
                                                    <Webcam
                                                      audio={false}
                                                      ref={webcamRef}
                                                      screenshotFormat="image/jpeg"
                                                      width={150}
                                                      height={150}
                                                      style={{
                                                        borderRadius: "8px",
                                                      }}
                                                    />
                                                    <div className="mt-2 d-flex gap-2">
                                                      <Button
                                                        variant="success"
                                                        size="sm"
                                                        onClick={() =>
                                                          captureImage(index)
                                                        }
                                                      >
                                                        Capture
                                                      </Button>
                                                      <Button
                                                        variant="secondary"
                                                        size="sm"
                                                        onClick={() =>
                                                          setShowWebcam(false)
                                                        }
                                                      >
                                                        Cancel
                                                      </Button>
                                                    </div>
                                                  </div>
                                                )}

                                                {/* Previews */}
                                                {Array.isArray(
                                                  sample.sample_photo
                                                ) &&
                                                  sample.sample_photo.length >
                                                    0 && (
                                                    <div className="d-flex flex-wrap gap-2 mt-1">
                                                      {sample.sample_photo.map(
                                                        (img, imgIndex) => (
                                                          <div
                                                            key={imgIndex}
                                                            style={{
                                                              position:
                                                                "relative",
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <img
                                                              src={img}
                                                              alt={`Sample ${imgIndex}`}
                                                              style={{
                                                                width: "100px",
                                                                height: "100px",
                                                                borderRadius:
                                                                  "8px",
                                                              }}
                                                            />
                                                            <button
                                                              type="button"
                                                              onClick={() =>
                                                                clearSampleImage(
                                                                  index,
                                                                  imgIndex
                                                                )
                                                              }
                                                              style={{
                                                                position:
                                                                  "absolute",
                                                                top: "5px",
                                                                right: "5px",
                                                                background:
                                                                  "transparent",
                                                                border: "none",
                                                                color: "red",
                                                                fontSize:
                                                                  "16px",
                                                                cursor:
                                                                  "pointer",
                                                                zIndex: 10,
                                                              }}
                                                            >
                                                              <FaTrash />
                                                            </button>
                                                          </div>
                                                        )
                                                      )}
                                                    </div>
                                                  )}
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>
                                    </>
                                  ))}
                                  {/* <button
                                type="button"
                                className="btn mt-3"
                                style={{
                                  backgroundColor: "#a36e29",
                                  color: "white",
                                  fontSize: "14px", // smaller text
                                  padding: "6px 12px", // smaller padding
                                  border: "none",
                                  borderRadius: "6px", // rounded corners
                                }}
                                onClick={() =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    sample: [
                                      ...prev.sample,
                                      {
                                        sample_photo: [],
                                        sample_des: "",
                                        sample_wt: "",
                                        sample_metaltype: "",
                                        sample_purity: "Manual",
                                        sample_custom_purity: "",
                                      },
                                    ],
                                  }))
                                }
                              >
                                Add Sample
                              </button> */}
                                  {(() => {
                                    const lastSample =
                                      formData.sample[
                                        formData.sample.length - 1
                                      ];

                                    const canAdd =
                                      lastSample?.sample_metaltype?.trim() &&
                                      lastSample?.sample_purity &&
                                      Number(lastSample?.sample_wt) > 0;

                                    return (
                                      <button
                                        type="button"
                                        className="btn mt-3"
                                        style={{
                                          backgroundColor: canAdd
                                            ? "#a36e29"
                                            : "gray",
                                          color: "white",
                                          fontSize: "14px",
                                          padding: "6px 12px",
                                          border: "none",
                                          borderRadius: "6px",
                                          cursor: canAdd
                                            ? "pointer"
                                            : "not-allowed",
                                        }}
                                        disabled={!canAdd}
                                        onClick={() =>
                                          setFormData((prev) => ({
                                            ...prev,
                                            sample: [
                                              ...prev.sample,
                                              {
                                                sample_photo: [],
                                                sample_des: "",
                                                sample_wt: "",
                                                sample_metaltype: "",
                                                sample_purity: "Manual",
                                                sample_custom_purity: "",
                                              },
                                            ],
                                          }))
                                        }
                                      >
                                        Add Sample
                                      </button>
                                    );
                                  })()}

                                  <Row className="mt-3">
                                    <Col md={3}>
                                      <label>Payment Mode</label>
                                      <InputField
                                        label=""
                                        name="payment_mode"
                                        type="select"
                                        value={formData.payment_mode || ""}
                                        onChange={(e) =>
                                          handleChange(
                                            "payment_mode",
                                            e.target.value
                                          )
                                        }
                                        options={[
                                          { value: "Cash", label: "Cash" },
                                          { value: "Online", label: "Online" },
                                          {
                                            value: "Bank Transfer",
                                            label: "Bank Transfer",
                                          },
                                          { value: "Cheque", label: "Cheque" },
                                          { value: "Card", label: "Card" },
                                        ]}
                                      />
                                    </Col>
                                    <Col md={3}>
                                      <label>Advance Amount</label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        style={{ border: "1px solid #a36e29" }}
                                        value={formData.advance_amt}
                                        onChange={(e) =>
                                          handleChange(
                                            "advance_amt",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Col>
                                  </Row>

                                  <div className="mt-4">
                                    <Button
                                      onClick={handleAssignmentSubmit}
                                      className="me-2"
                                      style={{
                                        backgroundColor: "#a36e29",
                                        borderColor: "#a36e29",
                                        color: "white",
                                      }}
                                    >
                                      Submit Assignment
                                    </Button>
                                    <Button
                                      variant="secondary"
                                      onClick={() => setShowAssignForm(false)}
                                    >
                                      Cancel
                                    </Button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="mt-3 d-flex justify-content-end">
              <Button
                className="create_but"
                onClick={async () => {
                  if (!generateSaleMode) {
                    setGenerateSaleMode(true);
                  } else if (selectedProductsGeneration.length > 0) {
                    // setOrderDetails((prev) =>
                    //   prev.map((item) =>
                    //     selectedProductsGeneration.some((p) => p.id === item.id)
                    //       ? { ...item, is_sales_generated: 1 }
                    //       : item
                    //   )
                    // );
                    // try {
                    //   await axios.post(`${baseURL}/mark-sales-generated`, {
                    //     ids: selectedProductsGeneration.map((p) => p.id),
                    //   });

                    //   console.log("Sales status updated in DB");
                    // } catch (err) {
                    //   console.error("Error updating sales status:", err);
                    // }
                    navigate("/sales", {
                      state: {
                        from: "orders",
                        orderDetails: selectedProductsGeneration,
                      },
                    });
                  }
                }}
                disabled={!showGenerateSale}
                style={{
                  backgroundColor:
                    selectedProductsGeneration.length > 0
                      ? "#a36e29"
                      : "#28a745",
                  borderColor:
                    selectedProductsGeneration.length > 0
                      ? "#a36e29"
                      : "#28a745",
                  padding: "8px 16px",
                  fontSize: "16px",
                  cursor: showGenerateSale ? "pointer" : "not-allowed",
                }}
              >
                Generate Sales
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OrderProductsPage;
